import React, { useEffect, useState, useCallback } from "react";
import AdminLayout from "@/components/AdminLayout";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RefreshCw, Search } from "lucide-react";

const AdminSystemLogs = () => {
  const [source, setSource] = useState("backend.err");
  const [q, setQ] = useState("");
  const [lines, setLinesArr] = useState([]);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set("source", source);
      params.set("lines", "500");
      if (q) params.set("q", q);
      const { data } = await api.get(`/admin/logs?${params}`);
      setLinesArr(data.lines || []);
      if (data.sources) setSources(data.sources);
    } catch (e) { toast.error("Failed to load logs", { description: e.response?.data?.detail || "" }); }
    finally { setLoading(false); }
  }, [source, q]);
  useEffect(() => { load(); }, [source, load]);

  return (
    <AdminLayout title="System logs" actions={
      <Button data-testid="logs-refresh" variant="outline" onClick={load} className="rounded-none"><RefreshCw size={14} className="mr-2" /> Refresh</Button>
    }>
      <div className="border border-border bg-card p-4 mb-4 flex flex-col md:flex-row gap-3">
        <Select value={source} onValueChange={setSource}>
          <SelectTrigger data-testid="log-source-filter" className="rounded-none h-11 w-full md:w-48"><SelectValue /></SelectTrigger>
          <SelectContent>
            {(sources.length ? sources : ["backend.out", "backend.err", "frontend.out", "frontend.err"]).map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="relative flex-1">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input data-testid="log-search" placeholder="Filter lines (case-insensitive)…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") load(); }} className="rounded-none h-11 pl-9" />
        </div>
      </div>

      <div className="border border-border bg-black text-green-200 font-mono text-xs overflow-auto max-h-[70vh]" data-testid="logs-viewer">
        {loading && <div className="p-4 text-muted-foreground">Loading…</div>}
        {!loading && lines.length === 0 && <div className="p-4 text-muted-foreground">No log lines match.</div>}
        {!loading && lines.map((l, i) => (
          <div key={`${i}-${(l || "").slice(0, 40)}`} className="px-3 py-0.5 border-b border-black/40 whitespace-pre-wrap break-all">{l}</div>
        ))}
      </div>
    </AdminLayout>
  );
};

export default AdminSystemLogs;
